window.bootstrap = require("../bootstrap");

import Vue from 'vue'

import Project from './components/Project'

import DeletePopup from './components/DeletePopup'

import ImageUpload from './components/ImageUpload'

import Statistics from './components/Statistics'

import ProjectCurrentLink from './components/Project/ProjectCurrentLink'

import Faq from './components/Faq'

import Vue2TouchEvents from 'vue2-touch-events'

( async () => { 

    window.Vue = Vue

    Vue.use(Vue2TouchEvents)

    const translations = await axios.get('/api/translations/admin/' +  document.documentElement.lang )

    if (translations) {

        const app = new Vue({

            el : '#admin',
    
            components : {
                Project,
                DeletePopup,
                Statistics,
                ProjectCurrentLink,
                Faq,
                ImageUpload
            },
    
            provide() {
                return {
                    language : translations.data
                }
            },
    
        });
    
        app.$mount("#admin");

        document.dispatchEvent( new CustomEvent('translationsLoaded', { detail : { translations : translations.data } } ) )

    }

})(); 

Vue.directive("display-none", function(el, binding) {
    el.style.display = !!binding.value ? "block" : "none";
});